import { Box, Stack } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import TkButton from "../../components/atoms/TkButton";
import TkBackButton from "../../components/molecules/TkBackButton";
import TkDataTable from "../../components/molecules/TkDataTable";
import TkDateDialog from "../../components/molecules/TkDateDialog";
import { BusinessContext } from "../../context/businessContext";
import { GlobalContext } from "../../context/globalContext";
import { ISearchForUnprocessedProps } from "../../type/contextType/businessContext/ISearchForUnprocessed";
import { httpAPI_APP105, httpAPI_APP108, httpAPI_APP109 } from "./api/request";
import { SearchField, TkSelectFormDialog } from "./components";
import { IAPI_APP105_Response } from "../../type/apiType";
import { headTitleList } from "./parts";
import "./_style.scss";

/**
 * SCRW110003 契約者未処理申請・届出等一覧
 * @return SCRW110003 契約者未処理申請・届出等一覧
 */
const SCRW110003 = () => {
  const navigate = useNavigate();
  const { setState: setBusinessState } = useContext(BusinessContext);
  const { state, setState } = useContext(GlobalContext);
  const { state: businessState } = useContext(BusinessContext);
  const searchForUnprocessed = {
    ...(businessState.searchForUnprocessed || {}),
  };
  const [searchReq, setSearchReq] = useState<ISearchForUnprocessedProps>({});
  const [formOnlyReason, setFormOnlyReason] = useState<string>();
  const [bodyList, setBodyList] = useState<any>([]);
  const [unprocessedApplyInfoList, setUnprocessedApplyInfoList] = useState<
    IAPI_APP105_Response["unprocessedApplyInfoList"]
  >([]);
  const [dateOpen, setDateopen] = useState(false);
  const [selectedContractor, setSelectedContractor] = useState<
    IAPI_APP105_Response["unprocessedApplyInfoList"]
  >([]);
  const [open, setOpen] = useState(false);
  const [managerList, setManagerList] = useState<any>([]);

  useEffect(() => {
    let manager;
    if (searchForUnprocessed?.manager) {
      manager = searchForUnprocessed?.manager;
    } else if (
      searchForUnprocessed?.businessType ||
      searchForUnprocessed?.reminderCount ||
      searchForUnprocessed?.systemUsage ||
      !!searchForUnprocessed?.prefectureList?.length ||
      searchForUnprocessed?.contractorNo
    ) {
      manager = undefined;
    } else {
      manager = state?.authInfo?.userId;
    }
    const searchParam = { ...searchForUnprocessed, manager };
    handleRefer(searchParam);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleRefer = async (param: ISearchForUnprocessedProps = {}) => {
    setSearchReq(param);
    try {
      const { contractorName, ...request } = param || {};
      const res = await httpAPI_APP105(request);
      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });
        setUnprocessedApplyInfoList(res.unprocessedApplyInfoList || []);
        let getManagerList = res.allManagerList?.map((item) => ({
          value: item.wamUserId,
          label: item.wamName,
        }));
        setManagerList(getManagerList);

        setBusinessState({
          ...businessState,
          searchForUnprocessed: param,
        });
      } else {
        setState({
          ...state,
          errorMsgId: res?.resultCd,
        });
      }
    } catch (e) {
      navigate("/error");
    }
  };

  useEffect(() => {
    const referBodyList = unprocessedApplyInfoList?.map((item) => [
      {
        children: item.businessTypeName,
        forSort: item.businessTypeName,
      },
      {
        children: `${item.contractorNo ?? ""}:${item.contractorName ?? ""}`,
        forSort: item.contractorNo,
      },
      {
        children: item.finalProcessDate,
        forSort: item.finalProcessDate,
        align: "center",
      },
      {
        children: item.guideSendDate,
        forSort: item.guideSendDate,
        align: "center",
      },
      {
        children: item.exceptDate,
        forSort: item.exceptDate,
        align: "center",
      },
      {
        children: item.exceptDateDiverge,
        forSort: item.exceptDateDiverge,
        align: "right",
      },
      {
        children: item.reminderCount,
        forSort: item.reminderCount,
        align: "right",
      },
      {
        children: item.lastRemindDate,
        forSort: item.lastRemindDate,
        align: "center",
      },
      {
        children: item.manager,
        forSort: item.manager,
      },
    ]);

    setBodyList(referBodyList ?? []);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [unprocessedApplyInfoList]);

  const selectCheck = (): boolean => {
    const list = selectedContractor?.length;
    let errorMsgId = "";
    if (!list) {
      errorMsgId = "TKMSG_SCR0044E";
    } else if (list > 1) {
      errorMsgId = "TKMSG_SCR0088E";
    }
    setState({
      ...state,
      errorMsgId,
    });

    if (errorMsgId) return true;

    return false;
  };

  //契約解除（法令違反）手続き ボタン 押下
  const handleProcedure = () => {
    if (selectCheck()) return;

    setBusinessState({
      ...businessState,
      common: {
        contractorNo: selectedContractor?.[0]?.contractorNo,
        contractorName: selectedContractor?.[0]?.contractorName,
      },
    });
    navigate("/SCRW070007", {
      state: { applyId: selectedContractor?.[0]?.applyId },
    });
  };

  // 督促メール作成
  const handleSendMail = () => {
    if (selectCheck()) return;

    navigate("/SCRW130003", {
      state: { taskId: selectedContractor?.[0].taskId },
    });
  };

  //督促日設定
  const hadleDateSet = () => {
    if (selectCheck()) return;

    if (
      selectedContractor?.[0].businessType === "JOB-35" ||
      selectedContractor?.[0].businessType === "JOB-39"
    ) {
      setDateopen(true);
    } else {
      setState({
        ...state,
        errorMsgId: "TKMSG_SCR0087E",
      });
    }
  };

  //請求放棄
  const handleRequestLeave = () => {
    if (selectCheck()) return;
    if (selectedContractor?.[0].businessType !== "JOB-35") {
      setState({
        ...state,
        errorMsgId: "TKMSG_SCR0111E",
      });
      return;
    }

    setOpen(true);
  };

  // 選択
  const handleSelect = (indexArr: number[]) => {
    const selectedList = unprocessedApplyInfoList?.filter((_, index) =>
      indexArr.includes(index)
    );
    setSelectedContractor(selectedList ?? []);
  };

  const handleSubmit = async (date?: any) => {
    setDateopen(false);
    try {
      const res = await httpAPI_APP108({
        contractorNo: selectedContractor?.[0].contractorNo,
        staffNo: selectedContractor?.[0].staffNo,
        limitationDate: date,
        businessType: selectedContractor?.[0].businessType,
        taskId: selectedContractor?.[0].taskId,
      });

      if (res.resultCd === "I0000") {
        handleRefer(searchReq);
        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch {
      navigate("/error");
    }
  };

  const handleCancel = () => {
    setDateopen(false);
  };

  //　退職手当金請求放棄更新API実行
  const handleOk = async () => {
    setOpen(false);
    let contractorNoes: string[] = [];
    let staffNoes: string[] = [];
    selectedContractor &&
      selectedContractor.forEach((item) => {
        contractorNoes.push(item.contractorNo ?? "");
        staffNoes.push(item.staffNo ?? "");
      });
    try {
      const res = await httpAPI_APP109({
        contractorNo: contractorNoes.join(","),
        staffNo: staffNoes.join(","),
        formOnlyReason: formOnlyReason,
      });

      if (res.resultCd === "I0000") {
        handleRefer(searchReq);
        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  return (
    <Box className="SCRW110003" data-testid="SCRW110003PageForTest">
      <SearchField
        managerList={managerList}
        onSearch={handleRefer}
        defaultValue={businessState.searchForUnprocessed}
      />

      <Box className="buttonGroup">
        <TkButton onClick={handleProcedure}>
          契約解除（法令違反）手続き
        </TkButton>
        <TkButton onClick={handleSendMail}>督促メール作成</TkButton>
        <TkButton onClick={hadleDateSet}>督促日設定</TkButton>
        <TkButton onClick={handleRequestLeave}>請求放棄</TkButton>
      </Box>

      <TkDataTable
        pagin
        checkSection={true}
        onCheckSectionWidth={handleSelect}
        bodyList={bodyList}
        headList={headTitleList}
      />
      <Stack className="backButton">
        <TkBackButton />
      </Stack>

      <TkDateDialog
        open={dateOpen}
        title="督促日設定"
        okText="登録"
        minDate={new Date("1900/01/01")}
        maxDate={new Date()}
        onOky={handleSubmit}
        cancelText="キャンセル"
        onCancel={handleCancel}
      />

      <TkSelectFormDialog
        open={open}
        onOky={handleOk}
        onCancel={() => setOpen(false)}
        setFormOnlyReason={setFormOnlyReason}
        title="確認（請求放棄する）"
        contextText="請求放棄を提出しますが、問題なければ、退職届のみ提出理由を選択してください。"
        cancelText="キャンセル"
        okText="登録"
      />
    </Box>
  );
};

export default SCRW110003;
